import { CoursesGeneralList } from '../../pages/Courses/CoursesGeneralList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/courses')({
  component: CoursesGeneralList,
})
